import { signalTextSchema } from "../protocol/signal.js";
import { signalTextEnvelopeSchema } from "../protocol/envelope.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-signals.ts
const signalTextRequestDataSchema = signalTextSchema.shape.data;
const SPACE_WAKE_CLIENT_MESSAGE_ID_REQUIRED_ERROR_CODE = "space.wake.client_message_id_required";
const SPACE_WAKE_CLIENT_MESSAGE_ID_REQUIRED_MESSAGE = "Wake requests from user-authored signal posts require clientMessageId.";
const SPACE_SIGNAL_AUTHORING_POLICY_REQUIRED_ERROR_CODE = "space.signal_authoring_policy_required";
const SPACE_AGENT_REPLY_CONTEXT_CHANGED_ERROR_CODE = "space.agent_reply.context_changed";
const SPACE_SIGNAL_AUTHORING_POLICY_REQUIRED_MESSAGE = "Signal posts must declare authoringPolicy before clientMessageId policy validation.";
const spaceSignalAuthoringPolicySchema = z$1.enum([
	"user_authored",
	"system_emitted",
	"legacy_nullable"
]);
const hasSpaceSignalWakeActivationTarget = (messageEnvelope) => (messageEnvelope?.activationTargets ?? []).some((target) => typeof target === "string" && target.trim().length > 0);
const hasSpaceSignalClientMessageId = (meta) => typeof meta?.clientMessageId === "string" && meta.clientMessageId.trim().length > 0;
const validateSpaceSignalClientMessageIdPolicy = (input) => {
	const createsWakeDispatch = hasSpaceSignalWakeActivationTarget(input.messageEnvelope);
	const authoringPolicy = spaceSignalAuthoringPolicySchema.safeParse(input.authoringPolicy);
	if (!authoringPolicy.success) return {
		ok: false,
		code: SPACE_SIGNAL_AUTHORING_POLICY_REQUIRED_ERROR_CODE,
		createsWakeDispatch,
		message: SPACE_SIGNAL_AUTHORING_POLICY_REQUIRED_MESSAGE,
		requiresClientMessageId: false
	};
	const requiresClientMessageId = authoringPolicy.data === "user_authored" && createsWakeDispatch;
	if (requiresClientMessageId && !hasSpaceSignalClientMessageId(input.meta)) return {
		ok: false,
		code: SPACE_WAKE_CLIENT_MESSAGE_ID_REQUIRED_ERROR_CODE,
		createsWakeDispatch: true,
		message: SPACE_WAKE_CLIENT_MESSAGE_ID_REQUIRED_MESSAGE,
		requiresClientMessageId: true
	};
	return {
		ok: true,
		createsWakeDispatch,
		requiresClientMessageId
	};
};
const postNormalMessageBodySchema = z$1.strictObject({
	workHandoffVersion: z$1.literal(1).optional(),
	text: signalTextRequestDataSchema.shape.text,
	deviceWait: signalTextRequestDataSchema.shape.deviceWait.optional(),
	contextSelection: signalTextRequestDataSchema.shape.contextSelection.optional(),
	attachments: signalTextRequestDataSchema.shape.attachments.optional(),
	files: signalTextRequestDataSchema.shape.files.optional(),
	messageEnvelope: signalTextRequestDataSchema.shape.messageEnvelope.optional(),
	replyTo: signalTextRequestDataSchema.shape.replyTo.optional(),
	meta: signalTextRequestDataSchema.shape.meta.optional()
}).superRefine((value, ctx) => {
	const { workHandoffVersion: _workHandoffVersion, ...signalData } = value;
	const parsed = signalTextRequestDataSchema.safeParse(signalData);
	if (parsed.success) return;
	const firstIssue = parsed.error.issues[0];
	ctx.addIssue({
		code: "custom",
		path: firstIssue?.path ?? [],
		message: firstIssue?.message ?? "Invalid normal message payload"
	});
});
const postNormalMessageResponseSchema = signalTextEnvelopeSchema;
//#endregion
export { SPACE_AGENT_REPLY_CONTEXT_CHANGED_ERROR_CODE, SPACE_SIGNAL_AUTHORING_POLICY_REQUIRED_ERROR_CODE, SPACE_SIGNAL_AUTHORING_POLICY_REQUIRED_MESSAGE, SPACE_WAKE_CLIENT_MESSAGE_ID_REQUIRED_ERROR_CODE, SPACE_WAKE_CLIENT_MESSAGE_ID_REQUIRED_MESSAGE, hasSpaceSignalWakeActivationTarget, postNormalMessageBodySchema, postNormalMessageResponseSchema, spaceSignalAuthoringPolicySchema, validateSpaceSignalClientMessageIdPolicy };

//# sourceMappingURL=space-signals.js.map